angular.module('bmsApp.merrymaids.job').controller('MMCloseJobSideCtrl', MMCloseJobSideCtrl);

MMCloseJobSideCtrl.$inject = [
	'$scope',
	'$filter',
];

function MMCloseJobSideCtrl(
	$scope,
	$filter
) {
	self = this;
	$scope.MMCloseJobSideCtrl = self;
	angular.extend(self, {
		jobTime: 0,
		jobTimeIsCustom: false,
		forecastedTimePerEmployee: 0,
		totalJobDuration: 0,
		totalEmployeeDuration: 0,
		averageDurationPerEmployee: 0,
		forecastedRouteJobDuration: 0,
		actualRouteJobDuration: 0,
		expandJobsInRoute: false,
	});

	this.$onInit = function () {
		let jobPartWatch = $scope.$watch(() => {
			return $scope.MMJobMainCtrl.jobPart;
		}, (newVal, oldVal, scope) => {
			if (angular.isObject(newVal)) {
				// jobPartWatch();
				reset();
				initJobPart();
			}
		}, true);
	};

	function reset() {
		angular.extend(self, {
			jobTime: 0,
			jobTimeIsCustom: false,
			forecastedTimePerEmployee: 0,
			totalJobDuration: 0,
			totalEmployeeDuration: 0,
			averageDurationPerEmployee: 0,
			forecastedRouteJobDuration: 0,
			actualRouteJobDuration: 0,
			expandJobsInRoute: false,
		});
	}

	function initJobPart() {
		updateJobTime();
		updateForecastedTimePerEmployee();
		updateTotalEmployeeDuration();
		updateAverageDurationPerEmployee();
		$scope.$watch(() => {
			return $scope.MMJobMainCtrl.jobPart.start_time;
		}, (newVal, oldVal, scope) => {
			updateTotalJobDuration();
		});
		$scope.$watch(() => {
			return $scope.MMJobMainCtrl.jobPart.end_time;
		}, (newVal, oldVal, scope) => {
			updateTotalJobDuration();
		});
		$scope.$watch(() => {
			return $scope.MMJobMainCtrl.jobPart.job_part_employees;
		}, (newVal, oldVal, scope) => {
			updateForecastedTimePerEmployee();
			updateTotalEmployeeDuration();
			updateAverageDurationPerEmployee();
		}, true);
		if ($scope.MMJobMainCtrl.jobPart.routes.length) {
			updateRouteJobDurations();
		}
	}

	function updateJobTime() {
		if ($scope.MMJobMainCtrl.jobPart.custom_clean_duration) {
			self.jobTime = $scope.MMJobMainCtrl.jobPart.job_minutes * 60;
			self.jobTimeIsCustom = true;
		} else if ($scope.MMJobMainCtrl.jobPart.is_first_clean && $scope.MMJobMainCtrl.jobPart.job.job_minutes_first_in) {
			self.jobTime = $scope.MMJobMainCtrl.jobPart.job.job_minutes_first_in * 60;
			self.jobTimeIsCustom = false;
		} else  {
			self.jobTime = $scope.MMJobMainCtrl.jobPart.job.job_minutes * 60;
			self.jobTimeIsCustom = false;
		}
	}

	function updateForecastedTimePerEmployee() {
		let employeeCollection = getSelectedEmployees();
		// converted back to minutes first so that rounding matches main close controller's
		self.forecastedTimePerEmployee = Math.round(self.jobTime / 60 / employeeCollection.length) * 60;
		if (self.forecastedTimePerEmployee === Infinity) {
			self.forecastedTimePerEmployee = 0;
		}
	}

	function updateTotalJobDuration() {
		self.totalJobDuration = $scope.MMJobMainCtrl.jobPart.end_time.diff($scope.MMJobMainCtrl.jobPart.start_time, 'seconds');
		if (self.totalJobDuration < 0) {
			self.totalJobDuration = 0;
		}
	}

	function updateTotalEmployeeDuration() {
		let employeeCollection = getSelectedEmployees();
		self.totalEmployeeDuration = 0;
		angular.forEach(employeeCollection, (job_part_employee) => {
			if (job_part_employee.duration_at_job) {
				self.totalEmployeeDuration += job_part_employee.duration_at_job * 60;
			}
		});
	}

	function updateAverageDurationPerEmployee() {
		let employeeCollection = getSelectedEmployees();
		self.averageDurationPerEmployee = Math.round(self.totalEmployeeDuration / employeeCollection.length);
	}

	function getSelectedEmployees() {
		return $filter('filter')($scope.MMJobMainCtrl.jobPart.job_part_employees, {'delete': '!true'});
	}

	function updateRouteJobDurations() {
		let jobPartSeconds;
		self.forecastedRouteJobDuration = 0;
		self.actualRouteJobDuration = 0;
		angular.forEach($scope.MMJobMainCtrl.jobPart.routes[0].job_parts, (jobPart) => {
			if (jobPart.is_first_clean) {
				jobPartSeconds = jobPart.job.job_minutes_first_in * 60
			} else {
				jobPartSeconds = jobPart.job.job_minutes * 60
			}
			self.forecastedRouteJobDuration += jobPartSeconds;
			if (!jobPart.closed) {
				self.actualRouteJobDuration += jobPartSeconds;
			}
		});
	}
}